import { useTranslations } from "next-intl";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import SearchResults from "@components/searchResults";
import { CalloutRoot, Heading, Text } from "@components/theming";

export default function EventPastError() {
  const t = useTranslations("EventPage");

  return (
    <CalloutRoot
      size="2"
      color="yellow"
      sharedClasses="relative flex-col !items-start whitespace-normal"
      shopsiteClasses="gap-1 !p-2 rounded-lg !bg-orange-100 !text-orange-700 ring-2 ring-orange-600 sm:w-fit mt-4"
      whitelabelClasses="mb-4"
    >
      <div className="flex gap-2 items-center">
        <ExclamationTriangleIcon className="hidden sm:block h-5 w-5" />
        <Heading
          as="h4"
          size="4"
          sharedClasses="uppercase"
          shopsiteClasses="text-xl font-black"
        >
          {t("statuses.datepast.heading")}
        </Heading>
      </div>
      <Text as="span" size="2" className="relative z-10">
        {t.rich("statuses.datepast.description", {
          button: (chunks) => (
            <SearchResults
              icon={<span className="font-bold underline">{chunks}</span>}
            />
          ),
        })}
      </Text>
    </CalloutRoot>
  );
}
